import { Dialog, DialogContent, Stack, Typography } from '@mui/material';
import { Quiz } from './components/quiz';
import {
  CurrentJobStep,
  DesiredJobStep,
  GoalStep,
  LocationInfoStep,
  ScholarityStep,
  WelcomeStep,
  CourseTypesStep,
  LanguagesStep,
  ContactInfoStep,
} from './components/steps';
import { useRecommendationProfile } from '@/context/recommendation-profile';
import { CourseTypes } from '@/models/catalog/course';
import {
  ProfileStepIds,
  type RecommendationProfile,
} from '@/models/recommendation';
import { Goal } from '@/models/recommendation';

export const ProfileQuiz = () => {
  const { profile, isProfileQuizOpen } = useRecommendationProfile();

  return (
    <Dialog
      open={isProfileQuizOpen}
      maxWidth="sm"
      fullWidth
      sx={{ '& .MuiDialog-paper': { height: '100%', sm: { height: 584 } } }}
    >
      <DialogContent
        sx={{ p: 3, display: 'flex', flexDirection: 'column', minHeight: 0 }}
      >
        <Typography variant="h2" mb={3}>
          Mapeamento de perfil
        </Typography>
        <Stack direction="column" flex={1} minHeight={0}>
          <Quiz
            key={profile?.current_step}
            profile={profile as RecommendationProfile}
          >
            <WelcomeStep id={ProfileStepIds.PresentationWelcome} />
            <CurrentJobStep id={ProfileStepIds.CurrentJob} />
            <GoalStep id={ProfileStepIds.Goal} />
            <DesiredJobStep
              id={ProfileStepIds.DesiredJob}
              shouldShow={(answers) => answers.goal === Goal.CareerChange}
            />
            <ScholarityStep id={ProfileStepIds.Scholarity} />
            <CourseTypesStep id={ProfileStepIds.CourseTypes} />
            <LanguagesStep
              id={ProfileStepIds.Languages}
              shouldShow={(answers) =>
                answers.course_types?.includes(CourseTypes.Languages) ?? false
              }
            />
            <LocationInfoStep id={ProfileStepIds.LocationInfo} />
            <ContactInfoStep id={ProfileStepIds.ContactInfo} />
          </Quiz>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
